export default class LiveStreamMappedEvent {
  constructor(data) {
    /**
     * Stream provider Match id
     * @type {string}
     */
    this.externalEventId = data.eeid;
    /**
     * SB Match id
     * @type {string}
     */
    this.internalEventId = data.ieid;
    /**
     * Integration broker (channel) id
     * @type {1|2|3}
     */
    this.integrationBrokerId = data.ibid;
    /**
     * Stream id
     * @type {string}
     */
    this.streamId = data.stid;
  }
}
